import ReactDOM from 'react-dom';
import ResultsBlock from './components/ResultsBlock';
// eslint-disable-next-line no-unused-vars,import/no-unresolved
import React from 'react';

jQuery( document ).ready( function() {
	const elements = document.querySelectorAll( '[data-name="qec-results"]' );

	if ( elements.length === 0 ) {
		return;
	}

	elements.forEach( element => {
		ReactDOM.render(
			<ResultsBlock attributes={ JSON.parse( element.dataset.attributes ) } />,
			element
		);
	} );
} );
